import './App.css';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState, useRef } from 'react';
import { ClipLoader } from "react-spinners";
import axios from 'axios';
import i18n from './lang/i18n';
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign, faAt, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { X } from 'lucide-react';

import MessageModal from './Pages/messageModal';

import Header from './Nav/header';
import Footer from './Nav/footer';
import Main from './Pages/main';
import Character from './Pages/character';
import AirDrop from './Pages/airdrop';
import Friends from './Pages/friends';
import Setting from './Pages/setting';
import Memories from './Pages/memories';
import Terms from './Pages/common/terms';
import PrivacyPolicy from './Pages/common/privacyPolicy';

import Coupons from './Pages/coupon/coupons';
import CouponDetail from './Pages/coupon/couponsDetail';
import CouponBarcode from './Pages/coupon/couponsBarcode';
import Shopping from './Pages/coupon/shopping';
import CategoriesList from './Pages/coupon/categoriesList';
import BrandsList from './Pages/coupon/brandsList';
import ShoppingDetail from './Pages/coupon/shoppingDetail';
import ShoppingHistory from './Pages/coupon/shoppingHistory';
import ShoppingBuy from './Pages/coupon/shoppingBuy';
import WalletDisabled from './Pages/coupon/walletDisabled';

import Coupons_Soda from './Pages/coupon_soda/coupons_soda';
import CouponDetail_Soda from './Pages/coupon_soda/couponsDetail_soda';
import CouponBarcode_Soda from './Pages/coupon_soda/couponsBarcode_soda';
import Shopping_Soda from './Pages/coupon_soda/shopping_soda';
import CategoriesList_Soda from './Pages/coupon_soda/categoriesList_soda';
import BrandsList_Soda from './Pages/coupon_soda/brandList_soda';
import ShoppingDetail_Soda from './Pages/coupon_soda/shoppingDetail_soda';
import ShoppingHistory_Soda from './Pages/coupon_soda/shoppingHistory_soda';
import ShoppingBuy_Soda from './Pages/coupon_soda/shoppingBuy_soda';


import { useDispatch, useSelector } from 'react-redux';
import {
    changeBackgroundImg, changeCircleImg, changeEnergy, changeFullScreenBtn, changeGold, changeHaptic, changeJackpotImg, changeLanguages, changeMobileType, changePlusEnergy, changeSound,
    checkDuplicateLogins, checkJackpot, checkjackpotCheck, checkJWT, checkLimitUpgrade, checkLimitUpgradeValue, checkMyData, checkMySkin, checkSecuretId, checkTapUpgrade, checkTapUpgradeValue,
    changeAlramModal, changeJackpotSound,
    changeSuperJackpotImg
} from './store';

import WebApp from '@twa-dev/sdk';
import { QRCodeCanvas } from 'qrcode.react';
import useWindowSize from './hook/useWindowSize'

function App() {
    const { t } = useTranslation();

    const DuplicateLogins = useSelector((state) => { return state.DuplicateLogins.value })
    const FullScreenBtn = useSelector((state) => { return state.FullScreenBtn.value })
    const backgroundImg = useSelector((state) => { return state.backgroundImg.value })
    const shoppingState = useSelector((state) => state.shoppingState.value);
    const developing = useSelector((state) => state.developing.value);
    const securetId = useSelector((state) => state.securetId.value);
    const myData = useSelector((state) => { return state.myData })

    const shoppingFlag = useSelector((state) => state.shoppingFlag.value);

    let navigate = useNavigate()
    let dispatch = useDispatch()
    let location = useLocation();

    const [loading, setLoading] = useState(0);
    const [loadingText, setLoadingText] = useState(t('loading_4'))
    const [prePath, setPrePath] = useState(location.pathname)
    const [message, setMessage] = useState("");

    const [checkWeb, setCheckWeb] = useState(false)

    const { Rwidth, Rheight } = useWindowSize();

    const platform = window.Telegram.WebApp.platform;
    const fullPath = location.pathname + location.hash;

    useEffect(() => {
        const imagesToPreload = [
            "/img/Philippines.png",
            "/img/south_korea.png",
            "/img/center-img.png",
            "/img/saycoin.png",
            "/newImg/icon_main_diamond.png",
            "/newImg/complete.png",
            "/newImg/complete_soda.png",
            "/newImg/expiration.png",
            "/newImg/expiration_soda.png",
            "/newImg/unavailable.png",
            "/newImg/banner_shopping_ph.png",
            "/newImg/banner_shopping_kr.png",
            "/newImg/splash_03(unused)(3000x5372).png",
            "/newImg/splash_03(unused)(3000x5372)_airdrop.png",
            "/newImg/vfx_confetti.gif",
            "/newImg/bomb.png",
            "/newImg/shoppingProfile.png",
            "/newImg/textbox.png",
            "/newImg/preparing.png",
            "/newImg/icon_goldenbox_big.png",
            "/newImg/icon_goldenbox_medium.png",
            "/newImg/icon_goldenbox_small.png",
            "/newImg/messageCard.png",
        ];

        preloadImages(imagesToPreload).then(() => {
            console.log("✅ 모든 이미지가 로드되었습니다!");
        });
    }, []);

    const preloadImages = (imageUrls) => {
        return new Promise((resolve) => {
            let loadedCount = 0;
            const totalImages = imageUrls.length;

            imageUrls.forEach((url) => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    // console.log(`✔️ 로드 완료: ${url}`);
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        resolve(); // ✅ 모든 이미지 로드 후 resolve 실행
                    }
                };
                img.onerror = (err) => {
                    console.error(`❌ 로드 실패: ${url}`, err);
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        resolve(); // ✅ 일부 이미지가 실패해도 전체 프로세스 종료
                    }
                };
            });
        });
    };

    useEffect(() => {
        if (['android', 'android_x', 'ios', 'tdesktop'].includes(platform)) {
            if (fullPath === '/') {
                window.Telegram.WebApp.BackButton.hide();
            } else {
                window.Telegram.WebApp.BackButton.show();
            }
        }
    }, [fullPath, platform]);

    useEffect(() => {
        if (['android', 'android_x', 'ios', 'tdesktop'].includes(platform)) {
            const handler = () => {
                navigate(-1);
            };

            window.Telegram.WebApp.BackButton.onClick(handler);

            return () => {
                window.Telegram.WebApp.BackButton.offClick(handler); // 특정 핸들러만 제거
            };
        }
    }, [navigate, platform]);

    // 미니앱 스크롤 변경
    window
        .TelegramWebviewProxy
        .postEvent('web_app_setup_swipe_behavior', JSON.stringify({ allow_vertical_swipe: false }));

    // 미니앱 헤더 색상 변경
    const data2 = JSON.stringify({ color: "#000000" });
    window
        .TelegramWebviewProxy
        .postEvent('web_app_set_header_color', data2);

    // 미니앱 하단 색상 변경
    const data3 = JSON.stringify({ color: "#000000" });
    window
        .TelegramWebviewProxy
        .postEvent('web_app_set_background_color', data3);


    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                console.log("🔵 미니앱 다시 열림 (포그라운드 복귀)");
                const tg = window.Telegram.WebApp;
                let initData = tg.initData;
                if (initData) {
                    const storedGoldLogs = JSON.parse(localStorage.getItem("goldLogs")) || [];
                    const storedEnergyLogs = JSON.parse(localStorage.getItem("energyLogs")) || [];

                    let goldCheck = storedGoldLogs.length == 0 ? true : GoldBulk(initData, storedGoldLogs);
                    let EnergyCheck = storedEnergyLogs.length == 0 ? true : EnergyBulk(initData, storedEnergyLogs);

                    if (goldCheck && EnergyCheck) {
                        fetchUserData(initData, 0);
                    }
                }
                tg?.HapticFeedback?.impactOccurred?.("light");
            } else {
                console.log("⚫️ 미니앱 내려감 (백그라운드)");
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        let obj = localStorage.getItem('FullScreen')
        dispatch(changeFullScreenBtn(obj == "true" ? true : false))
        if (obj == "true") {
            window
                .TelegramWebviewProxy
                .postEvent('web_app_request_fullscreen', true);
        }

        const objString = localStorage.getItem("language");
        if (objString) {
            onChangeLang(objString)
        }
        else {
            onChangeLang("ko-KR")
        }

        let hapticCheck = localStorage.getItem('haptic')
        let soundCheck = localStorage.getItem('sound')

        if (hapticCheck) dispatch(changeHaptic(hapticCheck == "true" ? true : false))
        if (soundCheck) dispatch(changeSound(soundCheck == "true" ? true : false))

        // 텔레그램 SDK 초기화
        if (window.Telegram) {
            const tg = window.Telegram.WebApp;
            tg.ready(); // SDK 준비 완료
            tg.expand();

            WebApp.setHeaderColor('#000000');
            WebApp.setBottomBarColor('#000000');

            // if ((tg?.platform == "tdesktop" || tg?.platform == "desktop" || tg?.platform == "web") && !shoppingState) {
            //     setCheckWeb(true)
            // }
            // else {
            setCheckWeb(false)

            // initData로부터 사용자 인증 정보 가져오기
            let initData = tg.initData;

            if (tg?.platform == "ios") {
                dispatch(changeMobileType(1))
            }
            else {
                dispatch(changeMobileType(0))
            }

            if (initData) {
                const storedGoldLogs = JSON.parse(localStorage.getItem("goldLogs")) || [];
                const storedEnergyLogs = JSON.parse(localStorage.getItem("energyLogs")) || [];

                let goldCheck = storedGoldLogs.length == 0 ? true : GoldBulk(initData, storedGoldLogs);
                let EnergyCheck = storedEnergyLogs.length == 0 ? true : EnergyBulk(initData, storedEnergyLogs);

                if (goldCheck && EnergyCheck) {
                    if (location.pathname.includes("wallets")) {
                        // 1) 처음(마운트 시) 즉시 ServerCheck 호출
                        setLoadingText(t('loading_0'));
                        let route = location.pathname.replace('/wallets', '')
                        navigate(route)
                        fetchUserData(initData, 0);
                    }
                    else if (location.pathname == "/showcoupon") {
                        setLoadingText(t('loading_1'));
                        navigate('/coupons')
                        setTimeout(() => {
                            fetchUserData(initData, 0);
                        }, 1000)
                    }
                    else {
                        if (shoppingState) {
                            navigate('/shopping')
                            fetchUserData(initData, 0);
                        } else {
                            navigate('/shopping')
                            ServerCheck(initData, 0);

                            // // 2) 오늘 ~ 자정까지 남은 시간을 계산
                            // const now = new Date();
                            // const nextMidnight = new Date();
                            // nextMidnight.setHours(24, 0, 0, 0); // 오늘 24:00(= 내일 00:00)
                            // const timeUntilMidnight = nextMidnight - now; // 밀리초 단위

                            // let dailyInterval; // 매일 자정마다 실행할 setInterval ID를 담을 변수

                            // // 3) 자정에 한 번 실행 후, 이후 매일 24시간 간격으로 반복
                            // const midnightTimeout = setTimeout(() => {
                            //     ServerCheck(initData, 1); // 자정에 호출

                            //     // 자정 이후 매 24시간마다 호출
                            //     dailyInterval = setInterval(() => {
                            //         ServerCheck(initData, 1);
                            //     }, 24 * 60 * 60 * 1000);
                            // }, timeUntilMidnight);

                            // // 4) 컴포넌트 언마운트 시점에 타이머/인터벌 정리
                            // return () => {
                            //     clearTimeout(midnightTimeout);
                            //     if (dailyInterval) {
                            //         clearInterval(dailyInterval);
                            //     }
                            // };
                        }
                    }
                }
            }
            // }
        }
    }, []);

    const [appHeight, setAppHeight] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            const windowHeight = window.innerHeight;

            if (windowHeight <= 700) {
                setAppHeight(true);
            } else {
                setAppHeight(false);
            }
        };
        handleResize();
        updateDimensions();
    }, [Rheight]);

    const onChangeLang = (e) => {
        i18n.changeLanguage(e);
        dispatch(changeLanguages(e));
    };

    const GoldBulk = async (token, storedGoldLogs) => {
        await axios.post(process.env.REACT_APP_API + '/api/gold/bulk', {
            goldBulk: storedGoldLogs
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                localStorage.removeItem("goldLogs");
                return true
            }
            return false
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const EnergyBulk = async (token, storedEnergyLogs) => {
        await axios.post(process.env.REACT_APP_API + '/api/energy/bulk', {
            energyBulk: storedEnergyLogs
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                localStorage.removeItem("energyLogs");
                return true
            }
            return false
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const ServerCheck = async (token, n) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/status/complete');
            const tmp = response.data;

            if ((tmp?.code === 1000 || tmp?.code === -1000) && Array.isArray(tmp.data)) {
                const items = tmp.data;
                const itemCount = items.length;

                // 아이템이 없는 경우
                if (itemCount === 0) {
                    if (tmp.code === 1000) {
                        fetchUserData(token, 0);
                    } else {
                        setLoadingText(t('loading_2'));
                    }
                    return;
                }

                const dataPoints = itemCount * 2;

                let randomValues = [];
                for (let i = 0; i < dataPoints; i++) {
                    const rand = 0.05 + Math.random() * 0.5;
                    randomValues.push(rand);
                }

                const sumOfRandoms = randomValues.reduce((acc, val) => acc + val, 0);
                const scaleFactor = 2500 / sumOfRandoms;

                randomValues = randomValues.map(val => val * scaleFactor);

                for (let i = 0; i < itemCount; i++) {
                    setLoadingText(`${items[i].step}`);
                    await new Promise(resolve =>
                        setTimeout(resolve, randomValues[i * 2])
                    );

                    setLoadingText(`${items[i].detail}`);
                    await new Promise(resolve =>
                        setTimeout(resolve, randomValues[i * 2 + 1])
                    );
                }

                if (tmp.code === 1000) {
                    fetchUserData(token, 0);
                } else {
                    setLoadingText(t('loading_3') + " (code -1000)");
                }
            } else {
                console.log("code가 1000/-1000이 아니거나 data가 배열이 아님:", tmp);
            }
        } catch (error) {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const fetchUserData = async (token, n) => {
        await axios.get(process.env.REACT_APP_API + `/api/user?`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                console.log(tmp?.data)

                dispatch(checkJWT(tmp?.data?.jwt ?? ""))
                dispatch(checkMySkin(tmp?.data?.skin ?? []))
                dispatch(checkMyData(tmp?.data?.user ?? []))
                dispatch(checkTapUpgrade(tmp?.data?.power[0].up_level ?? 1))
                dispatch(checkLimitUpgrade(tmp?.data?.power[1].up_level ?? 1))
                dispatch(checkTapUpgradeValue(tmp?.data?.power[0].up_value ?? 1))
                dispatch(checkLimitUpgradeValue(tmp?.data?.power[1].up_value ?? 1))
                dispatch(changePlusEnergy(tmp?.data?.energy ?? []))
                dispatch(changeJackpotImg(tmp?.data?.jackpotImg ?? []))
                dispatch(changeCircleImg(tmp?.data?.circle[0]?.circle_url ?? []))
                dispatch(changeBackgroundImg(tmp?.data?.background[0]?.bg_url ?? []))

                dispatch(changeGold(tmp?.data?.user?.user_gold ?? 0))
                dispatch(changeEnergy(tmp?.data?.user?.user_last_energy ?? 100))

                dispatch(checkSecuretId(tmp?.data?.user?.securet_code ?? null))
                dispatch(changeJackpotSound(tmp?.data?.sound ?? []))
                dispatch(changeSuperJackpotImg(tmp?.data?.superJackpot ?? []))

                if (n === 0) {
                    setTimeout(() => {
                        setLoading(1);
                    }, 500);
                }
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const [loca, setLoca] = useState(0)

    useEffect(() => {
        if (location.pathname == '/') setLoca(0)
        else if (location.pathname == '/character') setLoca(1)
        else if (location.pathname == '/randomBox') setLoca(1)
        else setLoca(2)
    }, [location])

    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    const updateDimensions = () => {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        if (windowWidth <= 450) {
            // 가로가 450 이하일 경우 화면 너비를 100%로 설정
            setDimensions({
                width: windowWidth,
                height: windowHeight,
            });
        } else if (windowWidth / 1 < windowHeight / 2) {
            // 가로가 더 작은 경우: 가로를 기준으로 계산
            setDimensions({
                width: windowWidth,
                height: windowWidth * 2, // 1:2 비율
            });
        } else {
            // 세로가 더 작은 경우: 세로를 기준으로 계산
            setDimensions({
                width: windowHeight / 2, // 1:2 비율
                height: windowHeight,
            });
        }
    };

    const [preparing, setPreparing] = useState(false)

    return (
        <div
            className='ratio'
            style={{
                height: `${dimensions.height}px`,
                width: `${dimensions.width}px`,
                minWidth: "340px",
                backgroundColor: "#000",
            }}
        >
            <MessageModal message={message} />
            {
                preparing
                    ?
                    <div style={{ width: "100%", height: "100%" }}>
                        <img src='/newImg/maintenance.png' style={{ width: "100%" }} />
                        <div style={{
                            position: "absolute", bottom: "40px", left: "50%", transform: "translateX(-50%)",
                            color: "#fff", fontSize: "26px", fontWeight: "bold", width: "100%", textAlign: "center"
                        }}>
                            {t('message_9')}
                        </div>
                    </div>
                    :
                    <div className="App">
                        {
                            DuplicateLogins
                                ?
                                <div className='web'>
                                    <div className='web-box'>
                                        <div style={{ fontSize: "26px", fontWeight: "700", marginBottom: '20px' }}>Duplicate login attempts detected.</div>
                                        <div style={{ fontSize: "26px", fontWeight: "700", }}>To continue using this device,</div>
                                        <div style={{ fontSize: "26px", fontWeight: "700", marginBottom: '20px' }}>please refresh.</div>
                                        <div style={{ fontSize: "24px", fontWeight: "400" }}><FontAwesomeIcon icon={faAt} style={{ fontSize: '22px', fontWeight: "400" }} />jciyeouido_bot</div>
                                    </div>
                                </div>
                                :
                                checkWeb
                                    ?
                                    <div className='web'>
                                        <div className='web-box'>
                                            <div style={{ fontSize: "26px", fontWeight: "700" }}>Play on your mobile</div>
                                            <div className='web-qr'>
                                                <QRCodeCanvas value={"https://t.me/jciyeouido_bot"} style={{ width: '100%', height: '100%' }} />
                                            </div>
                                            <div style={{ fontSize: "24px", fontWeight: "400" }}><FontAwesomeIcon icon={faAt} style={{ fontSize: '22px', fontWeight: "400" }} />jciyeouido_bot</div>
                                        </div>
                                    </div>
                                    :
                                    loading === 0 ? (
                                        <div className='loading' style={{ background: "#000", position: "relative", width: "100%", height: "100%" }}>
                                            <div style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <img 
                                                    src='/jciImg/jci_logo.png' 
                                                    alt="JCI Logo" 
                                                    className="logo-animation"
                                                    style={{
                                                        width: "auto",
                                                        height: "110px",
                                                        maxWidth: "300px"
                                                    }} 
                                                />
                                            </div>
                                            {prePath.includes("wallets") && (
                                                <>
                                                    <div className='loading-3' style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                                                        <ClipLoader
                                                            color="#F5AC1D"
                                                            size={70}
                                                            cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                                                            speedMultiplier={0.3}
                                                        />
                                                        <div style={{ fontSize: "25px" }}>Loading...</div>
                                                        <div style={{ height: "40px" }}>{loadingText}</div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        myData?.is_verified === 1 ? (
                                            <>
                                                {loca === 0 && (
                                                    <div
                                                        style={{
                                                            position: "fixed",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            backgroundImage: `url(${backgroundImg})`,
                                                            backgroundSize: "cover", // 이미지를 화면에 맞게 표시
                                                            backgroundRepeat: "no-repeat",
                                                            backgroundPosition: "center",
                                                            zIndex: 1, // 다른 요소 아래로 배치
                                                        }}
                                                    ></div>
                                                )}

                                                {loca < 2 && <Header />}
                                                {/* <Footer /> */}
                                                <Routes>
                                                    <Route path="/" element={<Main />} />
                                                    {/* <Route path="/character" element={<Character />} /> */}
                                                    {/* <Route path="/airdrop" element={<AirDrop />} /> */}
                                                    {/* <Route path="/friends" element={<Friends />} /> */}
                                                    {/* <Route path="/setting" element={<Setting />} /> */}
                                                    {/* <Route path="/memories" element={<Memories />} /> */}
                                                    <Route path="/terms" element={<Terms />} />
                                                    <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
                                                    {/* <Route path="/walletDisabled" element={<WalletDisabled />} /> */}

                                                    <Route path="/coupons" element={shoppingFlag == "한국" ? <Coupons /> : <Coupons_Soda />} />
                                                    <Route path="/couponsDetail/:couponId" element={shoppingFlag == "한국" ? <CouponDetail /> : <CouponDetail_Soda />} />
                                                    <Route path="/couponsBarcode" element={shoppingFlag == "한국" ? <CouponBarcode /> : <CouponBarcode_Soda />} />

                                                    <Route path="/shopping" element={shoppingFlag == "한국" ? <Shopping /> : <Shopping_Soda />} />
                                                    <Route path="/categoriesList" element={shoppingFlag == "한국" ? <CategoriesList /> : <CategoriesList_Soda />} />
                                                    <Route path="/brandsList" element={shoppingFlag == "한국" ? <BrandsList /> : <BrandsList_Soda />} />
                                                    <Route path="/shoppingDetail/:shoppingId" element={shoppingFlag == "한국" ? <ShoppingDetail /> : <ShoppingDetail_Soda />} />
                                                    <Route path="/shoppingHistory" element={shoppingFlag == "한국" ? <ShoppingHistory /> : <ShoppingHistory_Soda />} />
                                                    <Route path="/shoppingBuy/:shoppingId" element={shoppingFlag == "한국" ? <ShoppingBuy /> : <ShoppingBuy_Soda />} />

                                                    <Route path="*" element={<Navigate to="/" />} />
                                                </Routes>
                                            </>
                                        ) : (
                                            <AuthenticationModal setMessage={setMessage} isVerified={myData?.is_verified} />
                                        )
                                    )}
                    </div>
            }
        </div>
    );
}

function AuthenticationModal({ setMessage, isVerified }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const JWT = useSelector((state) => state.JWT.value);
    const myData = useSelector((state) => state.myData);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        memo: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isJustApplied, setIsJustApplied] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.name.trim().length === 0) {
            setMessage({ code: 1, msg: '이름을 입력해주세요.' });
            dispatch(changeAlramModal());
            return;
        }
        if (formData.phone.trim().length === 0) {
            setMessage({ code: 1, msg: '핸드폰번호를 입력해주세요.' });
            dispatch(changeAlramModal());
            return;
        }
        if (formData.memo.trim().length === 0) {
            setMessage({ code: 1, msg: '설명을 입력해주세요.' });
            dispatch(changeAlramModal());
            return;
        }
        
        setIsSubmitting(true);
        
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + '/api/user/apply-verify',
                {
                    name: formData.name,
                    phone: formData.phone,
                    memo: formData.memo
                },
                { headers: { Authorization: `Bearer ${JWT}` } }
            );
            
            // API 호출 후 1초 대기
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            const tmp = response.data;
            if (tmp?.code === 1000) {
                // 즉시 대기중 상태로 변경
                const currentMyData = myData?.value || {};
                dispatch(checkMyData({ ...currentMyData, is_verified: 2 }));
                setIsJustApplied(true); // 신청 직후 상태로 설정
                setIsSubmitting(false); // 스피너 종료하여 신청 완료 모달 표시
                
                // 사용자 데이터 다시 불러오기 (백그라운드)
                axios.get(process.env.REACT_APP_API + `/api/user?`, {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    }
                }).then((response) => {
                    let tmp = response.data
                    if (tmp?.code == 1000) {
                        dispatch(checkMyData(tmp?.data?.user ?? []))
                        setIsJustApplied(false); // 데이터 갱신 후 신청 직후 상태 해제
                    }
                }).catch((error) => {
                    if (error?.status === 999) {
                        dispatch(checkDuplicateLogins(true))
                    }
                })
            } else if (tmp?.code === 2000) {
                setIsSubmitting(false);
                setMessage({ code: 1, msg: tmp?.msg ?? '필수값이 누락되었습니다.' });
                dispatch(changeAlramModal());
            } else {
                setIsSubmitting(false);
                setMessage({ code: 1, msg: tmp?.msg ?? '요청 처리 중 오류가 발생했습니다.' });
                dispatch(changeAlramModal());
            }
        } catch (error) {
            setIsSubmitting(false);
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else if (error?.response?.status === 400) {
                const tmp = error?.response?.data;
                setMessage({ code: 1, msg: tmp?.msg ?? '필수값이 누락되었습니다.' });
                dispatch(changeAlramModal());
            } else if (error?.response?.status === 500) {
                setMessage({ code: 1, msg: error?.response?.data?.message ?? '서버 오류가 발생했습니다.' });
                dispatch(changeAlramModal());
            } else {
                setMessage({ code: 1, msg: '요청 처리 중 오류가 발생했습니다.' });
                dispatch(changeAlramModal());
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'memo' && value.length > 30) {
            return; // 30자 제한
        }
        if (name === 'phone') {
            // 숫자만 입력되도록 필터링
            const numericValue = value.replace(/[^0-9]/g, '');
            // 11자 제한
            if (numericValue.length > 11) {
                return;
            }
            setFormData(prev => ({
                ...prev,
                [name]: numericValue
            }));
            return;
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // 상태에 따른 메시지 결정
    // 0: 미인증, 1: 승인, 2: 대기중, 3: 거절
    let modalContent = null;

    if (isVerified === 0 || isVerified === null || isVerified === undefined) {
        // 미인증 유저
        const verifyEnabled = myData?.verifyEnabled ?? true;
        
        if (verifyEnabled) {
            // 신청 가능: 신청 form 표시
            modalContent = (
                <>
                    <div style={{ padding: "15px" }}>
                        <div
                            style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                textAlign: "center",
                                marginBottom: "12px"
                            }}
                        >
                            서비스 이용을 위해 승인 신청 후<br />관리자 승인이 필요합니다.
                        </div>
                        <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: "7px", position: "relative" }}>
                            <div style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                zIndex: 1,
                                pointerEvents: "none",
                                width: "75px"
                            }}>
                                <span style={{ fontSize: "14px", fontWeight: "500", display: "inline-block", width: "50px" }}>이름</span>
                                <span style={{ fontSize: "14px", color: "#999" }}>|</span>
                            </div>
                            <input
                                type="text"
                                name="name"
                                placeholder="입력"
                                required
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    paddingLeft: "85px",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    boxSizing: "border-box"
                                }}
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div style={{ marginBottom: "7px", position: "relative" }}>
                            <div style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                zIndex: 1,
                                pointerEvents: "none",
                                width: "75px"
                            }}>
                                <span style={{ fontSize: "14px", fontWeight: "500", display: "inline-block", width: "50px" }}>휴대폰</span>
                                <span style={{ fontSize: "14px", color: "#999" }}>|</span>
                            </div>
                            <input
                                type="tel"
                                name="phone"
                                placeholder="입력"
                                required
                                maxLength={11}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    paddingLeft: "85px",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    boxSizing: "border-box"
                                }}
                                value={formData.phone}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div style={{ marginBottom: "12px", position: "relative" }}>
                            <textarea
                                name="memo"
                                placeholder="메모"
                                required
                                maxLength={30}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    paddingBottom: "20px",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    minHeight: "70px",
                                    resize: "vertical",
                                    fontFamily: "inherit",
                                    boxSizing: "border-box"
                                }}
                                value={formData.memo}
                                onChange={handleInputChange}
                            />
                            <div style={{
                                position: "absolute",
                                bottom: "8px",
                                right: "10px",
                                fontSize: "12px",
                                color: "#999"
                            }}>
                                {formData.memo.length}/30
                            </div>
                        </div>
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            style={{
                                width: "100%",
                                padding: "12px",
                                background: isSubmitting ? "#ccc" : "#ffbb3f",
                                border: "none",
                                borderRadius: "5px",
                                cursor: isSubmitting ? "not-allowed" : "pointer",
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#000",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px"
                            }}
                        >
                            {isSubmitting ? (
                                <>
                                    <ClipLoader
                                        color="#000"
                                        size={16}
                                        cssOverride={{ borderWidth: "2px" }}
                                        speedMultiplier={0.8}
                                    />
                                    <span>처리중...</span>
                                </>
                            ) : (
                                "신청하기"
                            )}
                        </button>
                    </form>
                </div>
            </>
            );
        } else {
            // 신청 불가: 안내 메시지만 표시
            modalContent = (
                <div style={{ padding: "25px 15px" }}>
                    <div
                        style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            textAlign: "center"
                        }}
                    >
                        서비스 준비중입니다.
                    </div>
                </div>
            );
        }
    } else if (isVerified === 2) {
        // 대기중인 유저
        modalContent = (
            <div style={{ padding: "25px 15px" }}>
                <div
                    style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "center"
                    }}
                >
                    {isJustApplied ? (
                        <>
                            신청을 완료했습니다.<br />관리자 승인이 될때까지 기다려주세요.
                        </>
                    ) : (
                        <>
                            현재 이용 신청을 검토 중입니다.<br />승인이 완료될 때까지 조금만 기다려 주세요.
                        </>
                    )}
                </div>
            </div>
        );
    } else if (isVerified === 3) {
        // 거절된 유저
        modalContent = (
            <div style={{ padding: "25px 15px" }}>
                <div
                    style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "center"
                    }}
                >
                    승인이 거절되어 서비스 이용이 제한됩니다.<br />관련 문의는 고객센터를 이용해 주세요.<br />(010-7736-1414)
                </div>
            </div>
        );
    }

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "#000",
                    zIndex: 2000,
                    color: "#000"
                }}
            >
                <div
                    style={{
                        maxWidth: "400px",
                        width: "85%",
                        position: "absolute",
                        top: (isVerified === 0 || isVerified === null || isVerified === undefined) 
                            ? ((myData?.verifyEnabled ?? true) ? "15%" : "45%")
                            : "45%",
                        left: "50%",
                        transform: (isVerified === 0 || isVerified === null || isVerified === undefined)
                            ? ((myData?.verifyEnabled ?? true) ? "translateX(-50%)" : "translate(-50%, -65%)")
                            : "translate(-50%, -55%)",
                        background: "#fff",
                        borderRadius: "4px",
                        zIndex: 2001
                    }}
                >
                    {modalContent}
                </div>
                <div className='loading-4' style={{ zIndex: 1999 }}>
                    <img src='/jciImg/jci_logo.png' alt="JCI Logo" style={{
                        width: "auto",
                        height: "110px",
                        maxWidth: "300px"
                    }} />
                    {/* <div style={{ marginBottom: "20px", fontSize: "26px", color: "#fff" }}>서울여의도청년회의소</div> */}
                </div>
            </div>
        </>
    );
}

export default App;
